<template>
  <div id="Faq">
    <Hero class="lift" :formats="['webp']" src="../../../assets/faq-hero.jpg">
      <Wrap>
        <h1 class="title">
          {{ $t('title') }}
        </h1>
      </Wrap>
    </Hero>
    <SectionFaq :doShowHeadline="false" doShowAllQuestions :faqs="faqs" />
  </div>
</template>

<script>
import { actions, getters } from 'views/utils'
import Hero from 'views/components/Hero'
import Meta from 'views/mixins/Meta'
import SectionFaq from 'views/components/SectionFaq'

export default {
  mixins: [
    Meta(require('@/assets/social/faq.jpg')),
  ],
  components: { Hero, SectionFaq },
  computed: {
    faqs() {
      return this.query('faq')
    },
    ...getters(),
  },
  methods: actions('FETCH_FAQ'),
  created() {
    this.LOAD(this.FETCH_FAQ())
  },
}
</script>

<style lang="scss">
#Faq {
  .Hero {
    .image img {
      filter: brightness(0.55);
      height: 100%;
    }
  }
}
</style>

<i18n>
{
  "lt": {
    "meta": {
      "title": {
        "complement": "Nogrid",
        "inner": "Dažniausiai užduodami klausimai",
        "separator": "-"
      }
    },
    "title": "Dažniausiai užduodami klausimai"
  }
}
</i18n>
